(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dev-product-card-color-label"] && !Shopify.designMode) return;
  try {
    (function () {
    // Update the color label text and card image when hovering over a color sibling swatch link.
    // Restore both when the cursor leaves the swatches area.
    // Sibling packshots warm on card pointerenter (fine pointer only) so swatch hover is usually cached.
    // Event delegation — one listener set covers all cards on the page.

    /** @type {WeakMap<Element, {src: string, srcset: string}>} */
    const imageStateByCard = new WeakMap();
    /** @type {WeakSet<Element>} */
    const warmedCards = new WeakSet();
    /** @type {Set<string>} */
    const warmedUrls = new Set();

    const canHoverPreview =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    /**
     * Finds the currently visible product image in the card gallery.
     * @param {Element} card
     * @returns {HTMLImageElement | null}
     */
    const findGalleryImage = (card) => {
      const gallery = card.querySelector('[ref="cardGallery"]');
      if (!gallery) return null;
      return gallery.querySelector('slideshow-slide:not([hidden]) img') || gallery.querySelector('img');
    };

    /**
     * Warm a hover packshot URL into the browser HTTP cache.
     * @param {string | undefined} url
     */
    const warmUrl = (url) => {
      if (!url || warmedUrls.has(url)) return;
      warmedUrls.add(url);
      const image = new Image();
      image.decoding = 'async';
      image.src = url;
    };

    /**
     * Preload all sibling hover images for a product card (once).
     * @param {Element} card
     */
    const warmCardHoverImages = (card) => {
      if (!canHoverPreview || warmedCards.has(card)) return;
      warmedCards.add(card);

      const swatches = card.querySelectorAll('[data-hover-image]');
      for (const swatch of swatches) {
        if (!(swatch instanceof HTMLElement)) continue;
        warmUrl(swatch.dataset.hoverImage);
      }
    };

    // Capture: pointerenter does not bubble; fire as soon as the cursor enters the card.
    document.addEventListener(
      'pointerenter',
      (e) => {
        if (!(e.target instanceof Element)) return;
        const card = e.target.closest('product-card');
        if (!card) return;
        warmCardHoverImages(card);
      },
      true
    );

    document.addEventListener('mouseover', (e) => {
      const swatch = e.target.closest('.cs-color[data-color-label]');
      if (!swatch) return;
      const card = swatch.closest('product-card');
      if (!card) return;

      warmCardHoverImages(card);

      const label = card.querySelector('[data-dev-color-label]');
      if (label) {
        if (!label.hasAttribute('data-color-label-restore')) {
          label.setAttribute('data-color-label-restore', label.textContent || '');
        }
        const labelEl = swatch.querySelector('.cs-swatch-label');
        const next =
          (labelEl?.textContent || '').trim() ||
          (swatch.getAttribute('aria-label') || '').trim() ||
          swatch.dataset.colorLabel ||
          '';
        if (next) label.textContent = next;
      }

      const hoverImage = swatch.dataset.hoverImage;
      const img = findGalleryImage(card);
      if (!img) return;

      if (hoverImage) {
        if (!imageStateByCard.has(card)) {
          imageStateByCard.set(card, { src: img.src, srcset: img.srcset });
        }
        img.src = hoverImage;
        img.srcset = '';
      } else if (imageStateByCard.has(card)) {
        const state = imageStateByCard.get(card);
        img.src = state.src;
        img.srcset = state.srcset;
      }
    });

    document.addEventListener('mouseout', (e) => {
      const wrap = e.target.closest('[data-name="color-swatches"]');
      if (!wrap) return;
      if (wrap.contains(e.relatedTarget)) return;

      const card = wrap.closest('product-card');
      if (!card) return;

      const label = card.querySelector('[data-dev-color-label]');
      if (label?.hasAttribute('data-color-label-restore')) {
        label.textContent = label.getAttribute('data-color-label-restore') || '';
        label.removeAttribute('data-color-label-restore');
      }

      if (!imageStateByCard.has(card)) return;

      const state = imageStateByCard.get(card);
      if (!state) return;

      const img = findGalleryImage(card);

      if (img) {
        img.src = state.src;
        img.srcset = state.srcset;
      }

      imageStateByCard.delete(card);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
